export class UserProfile {
    public constructor() {
    }

    public drugStoreName?:string;
    public birthday?:string;
    public username?:string;
    public firstName?:string;
    public lastName?:string;
    public imageurl?:string;
    public mobilePhone?:string;
    public phoneNumber?:string;
    public nationalCode?:string;
    public roleName?:string;
    public positionName?:string;
    public insuranceNumber?:string;
}
